import { Box, Text } from '@streamelements/frontend-ui';
import { createFileRoute } from '@tanstack/react-router';
import { providerIcons } from '../../components/ProviderIcon';
import { AllowedProvider, platformPrettyName } from '../../constants/common';
import { z } from 'zod';

export const Route = createFileRoute('/auth/$provider/error')({
  component: ErrorPage,
  validateSearch: z
    .object({
      reason: z.string(),
    })
    .partial()
    .optional(),
});

function ErrorPage() {
  const { provider } = Route.useParams();
  const { reason = '' } = Route.useSearch() || ({} as never);
  const Icon = providerIcons[provider as AllowedProvider];

  console.log('Error connecting Multistreaming Provider:', provider, '\nReason:', reason);

  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <Box css={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <Box as="img" src="/logo.png" css={{ width: '3.25rem' }} />
        <Box as="img" src="/cross-mark.png" css={{ width: '1.25rem' }} />
        <Icon size="xl" css={{ '&&': { fontSize: '2.5rem' } }}></Icon>
      </Box>
      <Text.Heading level={5} css={{ m: 0 }} weight="bold">
        Connection failed
      </Text.Heading>
      <Text.Body css={{ color: '$textPrimary70', mb: '1rem' }}>
        The connection to {platformPrettyName[provider as AllowedProvider]} was not successful. <br />
        If you have any ad-blockers, please disable them temporarily and try again.
      </Text.Body>

      <Text.Body css={{ color: '$textPrimary70' }}>Reason</Text.Body>
      <Box
        as="code"
        css={{
          bgc: '$uiSecondary',
          br: '0.25rem',
          textAlign: 'start',
          border: '1px solid $divider',
          padding: '0.25rem 0.5rem',
          fontSize: '0.75rem',
          fontFamily: 'monospace',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
          width: 'min(100%, 400px)',
        }}
      >
        {reason}
      </Box>
    </Box>
  );
}
